import script from "./NumberListSingleValue.vue?vue&type=script&setup=true&lang=ts"
export * from "./NumberListSingleValue.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__